import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { LogoMark } from '../components/Logo';

function NotFound() {
  return (
    <div className="min-h-screen bg-surface text-fg flex items-center justify-center px-6">
      <div className="text-center">
        <LogoMark size={40} className="mx-auto mb-6" />
        <p className="font-mono text-orange text-sm mb-4">404 · NOT_FOUND</p>
        <h1 className="font-display text-6xl sm:text-8xl font-extrabold tracking-tight mb-4">
          Lost in the <span className="bg-gradient-to-r from-orange to-amber-400 bg-clip-text text-transparent">latent space.</span>
        </h1>
        <p className="text-fg-muted mb-8">This page doesn't exist — but every LLM is one API away.</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-orange hover:bg-orange-hover text-white font-semibold px-6 py-3 rounded-xl transition-colors"
        >
          <Home className="w-4 h-4" /> Back home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
